import axios from 'axios'
const token = $.rails.csrfToken();
const api = axios.create({
              baseURL:'/',
              headers: {
                'Accept': 'application/json',
                ...token && {
                  'X-CSRF-Token': token
                }
              }
            })

export { api }
